<template>
  <transition name="el-fade-in-linear">
    <div class="newsDetail2">
      <router-link to>
        <img
          @click="$router.back(-1)"
          class="backPic"
          src="../../static/images/back.png"
        />
      </router-link>
      <div class="detailTitle">喜报！北斗院荣获智慧交通产业三大奖项</div>
      <div class="detailTitleSecond">深圳北斗应用技术研究院 8月7日</div>
      <div class="line"></div>
      <div class="detailPic">
        <img
          class="newsDetailSize"
          src="../../static/images/newsDetailPic5.png"
        />
        <img
          class="newsDetailSize secondTextPic"
          src="../../static/images/newsDetailPic6.png"
        />
      </div>
      <div class="detailTitleText">
        8月7日下午，2020智慧交通产业发展论坛暨深圳市智慧交通产业促进会会员大会在深圳福田区召开。北斗院作为理事单位受邀参会，在大会上一举获得三大奖项，得到行业高度认可。
      </div>
      <div class="detailTitleText">
        本次智促会进行了2019年度产品与品牌评选颁奖，北斗院作为大交通领域的中坚力量，产品优秀，本领过硬，产品公共交通一体化智慧监测系统荣获2019年度智慧交通品牌产品奖、公交企业安全管理平台荣获2019年度智慧交通创新产品奖。在智慧交通建设单位中，北斗院脱颖而出，获得2019年度优秀会员单位称号。
      </div>
      <div class="detailTitleText">
        本次获奖的【公共交通一体化智慧监测系统】融合接入了城市公交、地铁、网约车、出租车、共享单车等海量交通数据，利用大数据赋能交通管理，实现人、车、路、场要素的综合分析、研判、管控，服务于交通监管部门交通运行监测、行业监管、交通规划决策支撑、应急指挥四个业务场景，助力构建安全、便捷、高效、绿色、经济的现代化综合交通体系。
      </div>
      <div class="detailTitleText">
        自主创新的【公交企业安全管理平台】是一款服务于公交企业安全管理的应用，以“安全智能化建设”为主线，以安全生产标准化和双重防御机制为准则，整合安全管理业务，实现事故事件处置及隐患整改闭环。
      </div>
      <div class="detailTitleText">
        公交企业安全管理平台已在深圳市公交企业落地使用，企业自平台上线以来，事故宗数降低35%，事故处置及时率、隐患整改完成率均达到100%，日常工作效率达到双100%，基层工作便捷性提高20%，安全管理效率得到有效提升，真正做到降低企业安全风险，减少企业损失。
      </div>
      <div class="detailTitleText">
        北斗院以大数据为核心，融合物联网、人工智能、人脸识别、地图引擎等先进技术构建一体化平台，助推产业智能升级。未来，北斗院将结合市交通运输局提出的“以信息化、智慧化引领全市交通运输行业现代化国际化一体化”的发展思路，发挥企业担当精神，为推动深圳市智慧交通建设发展尽心出力。
      </div>

      <div class="newsDetailFoot">
        <Foot />
      </div>
    </div>
  </transition>
</template>

<script>
import Foot from "./Foot";

export default {
  name: "Index",
  data() {
    return {};
  },
  mounted: function () {
    this.$router.afterEach((to, from, next) => {
      window.scrollTo(0, 0);
    });
  },
  components: {
    Foot,
  },
  methods: {},
};
</script>
<style scoped>
@import "./NewsDetail.css";
</style>



// WEBPACK FOOTER //
// src/views/NewsDetail2.vue